import { Component, Inject, TemplateRef, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UtilitesService } from "app/base-module/base-service/utilites.service";
import { Observable } from "rxjs";
import { BaseComponent } from "../../base-module/base-component/base.component";


export interface DialogData {
    id: number;
    titulo: string;
    campos: {
        data: boolean,
        cnpj: boolean
    };
}

@Component({
    selector: "app-filtro-caracteristica-coe",
    templateUrl: "./filtro-caracteristica-coe.component.html",
    styleUrls: ["./filtro-caracteristica-coe.component.scss"]
})
export class FiltroCaracteristicaCoeComponent extends BaseComponent {

    primeiroDia = this._utilitesService.primeiroDiaMes();

    data_operacao_inicio = new FormControl(this.primeiroDia);
    data_operacao_fim = new FormControl();

    nome = new FormControl("");
    cetip = new FormControl("");
    cnpj = new FormControl("");


    loadingSpinner!: boolean;
    loadingSpinnerStatus!: boolean;
    loadingSpinnerAssessor!: boolean;
    filteredOptions!: Observable<any[]>;
    listAssessor: any[] = [];
    listEscritorios: any[] = [];
    loadingSpinnerEscritorio: boolean = false;
    usuario: any;
    titulo!: string;

    @ViewChild("addButtonTmpl", { static: false }) addButtonTmpl!: TemplateRef<any>;
    constructor(
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<FiltroCaracteristicaCoeComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private _utilitesService: UtilitesService) {

        super(dialog, snackBar);
        this.titulo = this.data.titulo ?? "";
    }

    onNoClick(): void {
        this.dialogRef.close("cancel");
    }

    filtrar() {
        let inic = null;
        if (this.data_operacao_inicio.value != null) {
            inic = this._utilitesService.formatDateToString(this.data_operacao_inicio.value ?? new Date());
        }

        let fim = null;
        if (this.data_operacao_fim.value != null) {
            fim = this._utilitesService.formatDateToString(this.data_operacao_fim.value ?? new Date());
        }

        this.dialogRef.close({
            "nome": this.nome.value,
            "cnpj": this.cnpj.value,
            "cetip": this.cetip.value,
            "data_inicio": inic,
            "data_fim": fim
        });
    }

}